import { render, staticRenderFns } from "./SFDALabs.vue?vue&type=template&id=1355322f&scoped=true"
import script from "./SFDALabs.vue?vue&type=script&lang=js"
export * from "./SFDALabs.vue?vue&type=script&lang=js"
import style0 from "./SFDALabs.vue?vue&type=style&index=0&id=1355322f&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "1355322f",
  null
  
)

export default component.exports